import { FilterRenderData } from "../types";

const getOrder = (orderedColumns: string[], filter?: FilterRenderData) => {
  if (!filter?.activeFilter) return Number.MAX_SAFE_INTEGER;
  const index = filter
    ? orderedColumns.findIndex(
        (column) => column === filter?.activeFilter?.column,
      )
    : -1;
  return index !== -1 ? index : Number.MAX_SAFE_INTEGER;
};

const sortByOrder = (referenceColumns: string[], filters: FilterRenderData[]) =>
  [...filters].sort((item1, item2) => {
    const order1 = getOrder(referenceColumns, item1);
    const order2 = getOrder(referenceColumns, item2);
    return order1 - order2;
  });

const sortByActive = (filters: FilterRenderData[]) =>
  [...filters].sort(
    (item1, item2) =>
      Number(!!item2.activeFilter) - Number(!!item1.activeFilter),
  );

export const sortFilters = (
  filters: FilterRenderData[],
  referenceColumns?: string[],
) =>
  sortByActive(
    referenceColumns ? sortByOrder(referenceColumns, filters) : filters,
  );
